import { type PlanogramRenderedProduct } from "@augmodo/reusable-components";
import { formatMoney } from "@labeling-tools/ui-components/src/utils/helpers";
import { IconPhotoOff } from "@tabler/icons-react";

interface Props {
  item: PlanogramRenderedProduct;
}

/**
 * Hover card body for a reusable-viewer product cell — the counterpart of the
 * legacy OneLabelBox hover tooltip: enlarged pack shot with description,
 * facings and price. Shared by the coverage-beta and confirmation renderers;
 * laid out like the ReferenceProductDetectionBox hover card so both sides of
 * the screen read the same.
 */
export const PlanogramProductHoverContent = ({ item }: Props) => (
  <div className="w-48">
    <div className="h-40 w-full bg-gray-100 rounded flex items-center justify-center overflow-hidden">
      {item.imageUrl ? (
        <img
          src={item.imageUrl}
          className="size-full object-contain"
          alt={item.label || "Product"}
        />
      ) : (
        <IconPhotoOff size={24} color="#9ca3af" />
      )}
    </div>
    <div className="h-2" />
    {!!item.label && <div className="text-sm font-semibold">{item.label}</div>}
    <div className="text-xs text-gray-500">
      Facings: {item.product.facings ?? 0}
    </div>
    {typeof item.product.price === "number" && (
      <div className="text-xs text-gray-500">
        Price: {formatMoney(item.product.price)}
      </div>
    )}
  </div>
);
